import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-mates-ride-dialog',
  templateUrl: './mates-ride-dialog.component.html',
  styleUrls: ['./mates-ride-dialog.component.scss'],
})
export class MatesRideDialogComponent {
  pickup = false;
  dropoff = false;
  travelDate = false;

  today: Date;

  constructor(
    public dialogRef: MatDialogRef<MatesRideDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    this.today = new Date();
    switch (data.flag) {
      case 'pickup':
        this.pickup = true;
        break;
      case 'dropoff':
        this.dropoff = true;
        break;
      case 'travelDate':
        this.travelDate = true;
        break;
      default:
        break;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
